import { upsert, type RequestOptions } from '@check24/chronicle-api';
import { isCheck24Prod } from '../../config/check24-environment';
import type { ChronicleUpsert } from './chronicle.service';

// By hostname, like the login URLs: a test deployment can be built with the production configuration.
const requestOptions = {
  country: 'at',
  env: isCheck24Prod() ? 'production' : 'test',
} satisfies RequestOptions;

export const chronicleUpsert: ChronicleUpsert = (itemId, item) => upsert(itemId, item, undefined, requestOptions);
